import { gql } from "@apollo/client";

export const FETCH_ALL_PERMISSIONS = gql`
  query FetchAllPermissions($limit: Int, $offset: Int) {
    fetchAllPermissions(limit: $limit, offset: $offset) {
        data {
            permission {
                id
                name
                menu
                display
                created_at
                updated_at
                resources {
                    id
                    name
                    menu
                    display
                    created_at
                    updated_at
                    actions {
                        updated_at
                        id
                        name
                        action
                        created_at
                        role {
                            id
                            name
                            description
                            permissions {
                                created_at
                                updated_at
                                id
                                role_id
                                action_id
                            }
                        }
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
}
`;

export const CHECK_PERMISSIONS = gql`
query CheckPermission($role_id:UUID!,$action_id:UUID!) {
    checkPermission(role_id: $role_id, action_id: $action_id) {
         data {
            has_permission
        }
        error {
            code
            field
            message
        }
    }
}
`;
